import type { ReceiptTemplate } from '../schema';

export const doordashTemplate: ReceiptTemplate = {
  id: 'doordash',
  name: 'DoorDash Receipt',
  brand: 'DOORDASH',
  description: 'DoorDash food delivery receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'dd-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/doordash.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'DELIVERY RECEIPT',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dd-order',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: 'DD-847291034' },
          { id: 'date', label: 'Date:', value: '01/04/2026' },
        ],
        column2: [
          { id: 'time', label: 'Time:', value: '7:45 PM' },
          { id: 'dasher', label: 'Dasher:', value: 'Mike W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dd-restaurant',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'FROM: CHIPOTLE MEXICAN GRILL\n1200 Dark Avenue, Monsterville',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'dd-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'BURRITO BOWL', quantity: '1', price: '11.75', sku: '' },
          { id: '2', name: 'CHIPS & GUAC', quantity: '1', price: '5.95', sku: '' },
          { id: '3', name: 'FOUNTAIN DRINK', quantity: '1', price: '3.10', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dd-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '20.80', isBold: false, isLarge: false },
          { id: 'delivery', label: 'DELIVERY FEE', value: '3.99', isBold: false, isLarge: false },
          { id: 'service', label: 'SERVICE FEE', value: '2.49', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '2.25', isBold: false, isLarge: false },
          { id: 'tip', label: 'DASHER TIP', value: '5.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '34.53', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dd-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dd-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'DELIVERED TO:\n1200 Dark Avenue\nMonsterville, CA 94608\n\nTHANK YOU FOR USING DOORDASH',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

